import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardModule, Clipboard } from '@angular/cdk/clipboard';
import { CommonService } from '@shared/services/common.service';
import { CREATE_PLAN_CONSTANTS } from '@modules/monetize/components/create-plan/create-plan.constant';
import { Application } from '@enums/application.enums';
import { ApiCacheService, CacheTypes } from '@core/cache/api-cache.service';
import { APIENDPOINT } from '@core/api-url.enum';
import { Subject, takeUntil } from 'rxjs';
import moment from 'moment';

export interface BenefitCode {
  title: string;
  subtitle?: string;
  code: string;
  termsAndConditions: string[];
}

@Component({
  selector: 'app-benefit-code-accordion',
  templateUrl: './benefit-code-accordion.component.html',
  styleUrls: ['./benefit-code-accordion.component.scss'],
  standalone: true,
  imports: [CommonModule, ClipboardModule]
})
export class BenefitCodeAccordionComponent {
  @Input() benefit: BenefitCode;
  @Input() expanded: boolean = false;
  @Input() showAccordionText: string = CREATE_PLAN_CONSTANTS.SHOW_DETAILS;
  @Input() hideAccordionText: string = CREATE_PLAN_CONSTANTS.HIDE_DETAILS;

  CREATE_PLAN_CONSTANTS = CREATE_PLAN_CONSTANTS;
  Application = Application;
  destroy$ = new Subject<void>();
  couponUsage: any = null;

  constructor(
    private readonly clipboard: Clipboard,
    private readonly cs: CommonService,
    private readonly apiCacheService: ApiCacheService
  ) {}

  toggle(benefit: any): void {
    this.expanded = !this.expanded;
    this.couponUsage = null;
    if (this.expanded && benefit?.code) {
      this.checkCodeUsage(benefit);
    }
  }

  copyCode(): void {
    if (this.benefit?.code) {
      this.clipboard.copy(this.benefit.code);
      this.cs.showSuccessMessage('Code copied to clipboard');
    }
  }

  checkCodeUsage(benefit: any) {
    this.apiCacheService
      .get(
        APIENDPOINT.subscriptionCouponCodeUsag(benefit.code),
        CacheTypes.ALWAYS_FRESH
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.couponUsage = res.data;
            this.couponUsage.validTill = this.couponUsage?.end_date ? moment(this.couponUsage?.end_date).format('MMM DD, YYYY') : '';
          }
        }
      );
  }
}
